export default __webpack_public_path__ + "static/media/Applinces.93b75228.svg";